import { useState, useEffect, useMemo } from 'react'
import dayjs from 'dayjs'

import type { Dayjs } from 'dayjs'

const TIMER_INTERVAL = 60000

const useCurrentTime = (): Dayjs => {
  const [currentTime, setCurrentTime] = useState(new Date())

  useEffect(() => {
    let interval
    const now = new Date()
    const delay = (60 - now.getSeconds()) * 1000 - now.getMilliseconds()

    setTimeout(() => {
      setCurrentTime(new Date())
      interval = setInterval(() => {
        setCurrentTime(new Date())
      }, TIMER_INTERVAL)
    }, delay)

    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [])

  return useMemo(() => dayjs(currentTime), [currentTime])
}

export default useCurrentTime
